import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

async function getData(listingId) {
  const body = {
    resources: {
      users: [
        'id',
        'identity_verified_state',
        'preferred_name',
        'first_name',
        'last_name',
        {
          avatar: ['aws_s3_key']
        }
      ]
    },
    pagination: { limit: 200, page: 1 }
  }
  const response = await client.post(`/v2/listings/${listingId}/inquiries`, body)
  return response.data?.users
}

const useGetListingInquiries = (listingId, config) => {
  const { isLoading, data } = useQuery({
    queryKey: ['listing', 'inquiries', listingId],
    queryFn: () => getData(listingId),
    staleTime: 5 * 60000,
    enabled: !!listingId,
    ...config
  })

  return { isLoading, data: data || [] }
}

export default useGetListingInquiries
